import api from '@pray/shared/utils/api';

import type { SeriesTag } from './getSeriesTags';

export interface RemoveSeriesTagResponse {
  data: SeriesTag[];
}

export interface RemoveSeriesTagParams {
  artistId: string;
  seriesId: string;
  tagId: string;
}

/**
 * Remove a tag from a content series
 */
export async function removeSeriesTag({
  artistId,
  seriesId,
  tagId,
}: RemoveSeriesTagParams): Promise<RemoveSeriesTagResponse> {
  const url = `/web/studio/artists/${artistId}/content-series/${seriesId}/tags/${tagId}`;
  const response = await api.executeDeleteRequest<RemoveSeriesTagResponse>(url);
  return response.data;
}
